module.exports = __webpack_public_path__ + "img/clone.180b3a6d.svg";